<div class="content-page">
    <img src="/assets/images/robot.svg"
        alt="Unauthorized" />
    <h4>{{'common.unauthorized_msg1' | translate}}..!</h4>
    <h6>{{'common.unauthorized_msg2' | translate}}.</h6>
</div>